export const FETCH_CLICK_AND_COLLECT_ORDER_DETAIL_PENDING =
  'FETCH_CLICK_AND_COLLECT_ORDER_DETAIL_PENDING';
export const FETCH_CLICK_AND_COLLECT_ORDER_DETAIL_REJECTED =
  'FETCH_CLICK_AND_COLLECT_ORDER_DETAIL_REJECTED';
export const FETCH_CLICK_AND_COLLECT_ORDER_DETAIL_FULFILLED =
  'FETCH_CLICK_AND_COLLECT_ORDER_DETAIL_FULFILLED';
export const SET_CLICK_AND_COLLECT_ORDER_DETAIL_SELECTED_IDS =
  'SET_CLICK_AND_COLLECT_ORDER_DETAIL_SELECTED_IDS';



// WEBPACK FOOTER //
// ./src/constants/clickAndCollectOrderDetail.js